import React, {
  useContext,
} from 'react';
import { SizeTileGroup, SizeTile } from 'anf-core-react';
import ESpotContent from '../ESpotContent/ESpotContent';
import triggerSoldOutSizeAnalytics from '../../helpers/soldOutSizeAnalyticsHelper';
import ProductPageContext from '../../contexts/ProductPageContext';

export default function SecondarySizeTiles({
  secondarySizeArray,
  secondarySizeTileHandler,
  secondaryTileSize,
  secondarySizeGroupHeading,
  eSpotContent,
  tmntData,
}) {
  const displaySelectedTileSize = secondarySizeArray?.find(
    (primarySizeObj) => primarySizeObj.selected,
  );

  const ProductPageState = useContext(ProductPageContext);

  const secondarySizeTiles = secondarySizeArray
    && secondarySizeArray.map((secondarySizeObj) => {
      const {
        value, label, sizeText, available, selected, enableSelectableSoldOutSizeTiles,
      } = secondarySizeObj;

      const handleTileClick = (event) => {
        if (!available) {
          triggerSoldOutSizeAnalytics({
            productPageState: ProductPageState,
            sizeType: 'secondary',
            label,
          });
        }
        if (secondarySizeTileHandler) secondarySizeTileHandler(event);
      };

      return (
        <SizeTile
          key={sizeText}
          isChecked={selected}
          onChange={handleTileClick}
          id={`radio_size_secondary_${sizeText}`}
          name="size-secondary"
          type="radio"
          size={label.length > 3 ? 'long' : secondaryTileSize}
          value={value}
          label={label}
          isUnavailable={!available}
          hasDisabledStyle={enableSelectableSoldOutSizeTiles}
          data-testid="sitg-input-inner-wrapper"
          data-size={label}
        />
      );
    });

  return secondarySizeTiles?.length > 1 ? (
    <div className="product-sizes_secondary-mfe" data-testid="secondary-size-tiles">
      <div className="product-secondary-size-selection-header_wrapper-mfe">
        <h3 className="product-sizes__name">
          <div>
            {secondarySizeGroupHeading}
            :
            {' '}
            <span className="product-sizes__name__selected-size" data-testid="selected-size">
              {displaySelectedTileSize?.label}
            </span>
          </div>
        </h3>
        <ESpotContent eSpotData={eSpotContent?.pdp_comparelengths} />
      </div>

      <SizeTileGroup
        legend={
          <span className="screen-reader-text">{`${tmntData?.selectedSize?.value} ${secondarySizeGroupHeading}`}</span>
        }
      >
        {secondarySizeTiles}
      </SizeTileGroup>
    </div>
  ) : (
    ''
  );
}

SecondarySizeTiles.defaultProps = {
  secondarySizeGroupHeading: '',
};
